import React from "react";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router";

import { useSelector } from "@tdp/core";
import {
  AnalyticsV2WidgetLoadingState,
  AnalyticsV2WidgetSize,
  EntityType,
  Period,
  ChartMapBubble,
  IPeriodWiseCountryData,
  SingleWidgetContainer,
  EmptyState,
  AppAnalyticsRegionDetailsRoute
} from '@tdp/modules/apps';

export const MapWidget: React.FC<{
  status: AnalyticsV2WidgetLoadingState
  size: AnalyticsV2WidgetSize
  data?: IPeriodWiseCountryData
  header: string
}> = React.memo(({ header, size, data, status }) => {

  const intl = useIntl();
  const filter = useSelector((state) => state.analyticsFilter.filters);
  const navigate = useNavigate();
  const { appId } = useParams();

  const chartLegend = filter.entityType === EntityType.User ?
    intl.formatMessage({
      defaultMessage: "Active users",
      description: "Short name for the metric analyticsMetricNameMau30. For metric explanation see analyticsMetricTooltipTextMau30"
    }) :
    intl.formatMessage({
      defaultMessage: "Active tenants",
      description: "Short name for the metric analyticsMetricNameMat30. For metric explanation see analyticsMetricTooltipTextMat30"
    });

  const widget = data?.[Period.Monthly]
    ? <ChartMapBubble data={data[Period.Monthly]} legend={chartLegend} />
    : <EmptyState />;

  // eslint-disable-next-line @typescript-eslint/no-unused-expressions
  const showDetailedView = () => { appId && navigate(AppAnalyticsRegionDetailsRoute.replace(":appId", appId)) }

  return <SingleWidgetContainer
    size={size}
    header={header}
    loadingState={status}
    widget={widget}
    onViewDetails={showDetailedView}
  />
});